<form class="lv-artefact-container"
      [ngClass]="!!uiArtefakt?.Ausrichtung ? uiArtefakt?.Ausrichtung : uiAusrichtung">
  <div class="lv-artefact" [ngClass]="uiArtefakt.BreiteInPixel">
    <lv-label-tooltip [label]="uiArtefakt.Text" [labelSymbol]="nestedSymbol"
                      [isPflichtfeld]="uiArtefakt.PflichtfeldJN"
                      [tooltip]="uiArtefakt.InfoTextTooltipCollapsable"
                      [isCollapsable]="uiArtefakt.InfoTextTooltipCollapsableTyp === 'Collapsable'"></lv-label-tooltip>
    <mat-button-toggle-group
        [ngClass]="{'lv-error-state': !!getError()}"
        #buttonToggleGroup="ngModel" [(ngModel)]="uiArtefakt.WertEingabe"
        [name]="uiArtefakt.Identifikator" [id]="uniqueId">
      <mat-button-toggle *ngFor="let element of loadedOptions$ | async"
                         [value]="element.WertEingabe"
                         [disabled]="isDisabled"
                         (change)="changeSelection(element.WertEingabe)">{{element.WertAnzeige}}</mat-button-toggle>
    </mat-button-toggle-group>
    <mat-error class="lv-error-meldung-style" [ngClass]="uiArtefakt.BreiteInPixel"
               *ngIf="getError() as error" (click)="onErrorClick()">
      <div class="lv-control-error"
           [ngClass]="{'lv-show-untruncated-error': showUntruncatedError}">{{error}}</div>
    </mat-error>
  </div>
  <lv-infotext-permanent [InfoTextPermanent]="uiArtefakt.InfoTextPermanent"></lv-infotext-permanent>
</form>
